if ('URLSearchParams' in window) {
  const isMaintainingQueryParameters = sessionStorage.getItem('twoyou_plp_maintain_params');
  const hasUrlSearchParameters = window.location.search;

  const allowedLinkFilter = link => {
    // Allow links with Append inbound parameters
    if (link?.attributes['data-appendparams']?.value === '1') {
      return true;
    }
    // avoid external links
    if (link?.hostname !== window?.location?.hostname) {
      return false;
    }

    // avoid sitemap
    if (link?.pathname?.includes('.xml')) {
      return false;
    }

    return true;
  };

  const updatePageLinks = () => {
    const urlParameters = new URLSearchParams(hasUrlSearchParameters);

    // remove search parameter
    urlParameters.delete('s');

    // remove previous policy parameter
    urlParameters.delete('previous_policy_version');

    const inWpPreview = urlParameters.has('preview');

    if (inWpPreview) {
      return;
    }

    if (Array.from(urlParameters.entries())?.length >= 25) {
      return;
    }

    // filter page links
    const filteredPageLinks = Array.from(
      document.querySelectorAll('#page a, .footer a'),
    ).filter(link => allowedLinkFilter(link));

    if (filteredPageLinks?.length > 0) {
      filteredPageLinks.forEach(link => {
        const linkParameters = new URLSearchParams(link?.search);

        urlParameters.forEach((value, key) => {
          const hasQueryParameterKey = linkParameters.has(key);
          const hasQueryParameterKeyValue = linkParameters.getAll(key).includes(value);

          // conditionally adds key/value to parameter
          if (!hasQueryParameterKey || (hasQueryParameterKey && !hasQueryParameterKeyValue)) {
            linkParameters.append(key, value);
          }
        });

        link.search = linkParameters.toString(); // eslint-disable-line no-param-reassign
      });
    }
  };

  if (!isMaintainingQueryParameters && hasUrlSearchParameters) {
    sessionStorage.setItem('twoyou_plp_maintain_params', true);
    updatePageLinks();
  }

  if (isMaintainingQueryParameters && hasUrlSearchParameters) {
    updatePageLinks();
  }
}
